import type { RoomStatus, SpecStatus, ScheduleStatus, Trade } from '@/types/database';

// Room types were removed from the product in migration 0027. A room's page
// (Interior or Exterior) is now `rooms.is_exterior`, not derived from a type.

export const ROOM_STATUS_LABEL: Record<RoomStatus, string> = {
  proposed: 'Proposed', approved: 'Approved', completed: 'Completed',
};

export const SPEC_STATUS_LABEL: Record<SpecStatus, string> = {
  proposed: 'Proposed', approved: 'Approved', ordered: 'Ordered',
  shipped: 'Shipped', delivered: 'Delivered', installed: 'Installed',
  rejected: 'Rejected', backordered: 'Backordered',
};

export const SCHEDULE_STATUS_LABEL: Record<ScheduleStatus, string> = {
  planned: 'Planned', in_progress: 'In progress', blocked: 'Blocked',
  complete: 'Complete', skipped: 'Skipped',
};

export function asOptions<T extends string>(map: Record<T, string>): { value: T; label: string }[] {
  return (Object.entries(map) as [T, string][]).map(([value, label]) => ({ value, label }));
}

/**
 * Subcontractor trades (0018). Lived in project-detail.ts until the contact
 * modal was shared with the firm-wide contacts page (2026-09-22) and two views
 * needed it.
 */
export const TRADE_LABEL: Record<Trade, string> = {
  plumbing: 'Plumbing', electrical: 'Electrical', carpentry: 'Carpentry',
  paint: 'Paint', tile: 'Tile', hvac: 'HVAC', drywall: 'Drywall',
  flooring: 'Flooring', cabinetry: 'Cabinetry', countertops: 'Countertops',
  landscape: 'Landscape', roofing: 'Roofing', general: 'General contracting',
  other: 'Other',
};
